import { FC } from "react";
import { useParams } from "react-router-dom";
import { ErrorFallback, Loader } from "@/components";
import useSetClient from "@/hooks/useSetClient";
import useSingleEvent from "../../hooks/useSingleEvent";
import { SingleEventUI } from "./SingleEvent.ui";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Theme } from "@radix-ui/themes";

export const SingleEvent: FC = (): JSX.Element => {
  const { zoneId, slug } = useParams();

  const { zoneItem, loadingZone } = useSetClient(zoneId);
  const { eventItem, loading, error } = useSingleEvent(slug);

  const theme =
    themeMap[zoneItem?.theme.toUpperCase()] ||
    themeMap[brand.brandTheme.toUpperCase()] ||
    "violet";
  const radius = themeRadiusMap[zoneItem?.theme.toUpperCase()] || "none";

  if (error) {
    return <ErrorFallback>Failed to load news article</ErrorFallback>;
  }

  if (loadingZone || loading) {
    return <Loader />;
  }

  if (zoneId) {
    return (
      <Theme appearance="dark" accentColor={theme} radius={radius}>
        <SingleEventUI data={eventItem as any} zone={zoneItem} />
      </Theme>
    );
  }

  return <SingleEventUI data={eventItem as any} />;
};
